export default {
      id: "icon-settings-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-settings",
      toString: function () {
        return this.url;
      }
    }